import { memo } from 'react';
import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  useEventCallback,
} from '@mui/material';
import { ForeignVM } from 'practice/view-models/pratice-actual-residence';
import { NewResidenceVM } from 'practice/view-models/practice-edit-residence';
import { FormikErrors, FormikTouched } from 'formik';
import ItalianForm from './italian';
import ForeignForm from './foreign';
import { ItalianVM } from 'shell/view-models/register-office-practice-vm';

interface FormProps {
  values?: NewResidenceVM;
  onChange: (key: keyof NewResidenceVM, value: NewResidenceVM[keyof NewResidenceVM]) => void;
  errors?: FormikErrors<NewResidenceVM>;
  touched?: FormikTouched<NewResidenceVM>;
  disabled?: boolean;
}

const AccordionNewReidenceFormComponent = ({
  values,
  onChange,
  errors,
  touched,
  disabled,
}: FormProps): React.ReactElement => {
  const onChangeItalian = useEventCallback(
    (key: keyof ItalianVM, value: ItalianVM[keyof ItalianVM]) => {
      onChange('italian', {
        ...(values?.italian || {}),
        [key]: value,
      });
    }
  );

  const onChangesItalian = useEventCallback((newValues: ItalianVM) => {
    onChange('italian', {
      ...(values?.italian || {}),
      ...newValues,
    });
  });

  const onChangeForeign = useEventCallback(
    (key: keyof ForeignVM, value: ForeignVM[keyof ForeignVM]) => {
      onChange('foreign', {
        ...(values?.foreign || {}),
        [key]: value,
      });
    }
  );

  const onChangesForeign = useEventCallback((valuesForeign: ForeignVM) => {
    onChange('foreign', {
      ...valuesForeign,
    });
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="Residenza"
            id="checkedResidence"
            value={values?.checkedResidence || 'false'}
            onChange={() => {
              onChange('checkedResidence', !Boolean(values?.checkedResidence));
            }}
          >
            <FormControlLabel value="false" control={<Radio />} label="Residenza Italia" />
            <FormControlLabel value="true" control={<Radio />} label="Residenza Estera" />
          </RadioGroup>
        </FormControl>
      </Grid>

      {values?.checkedResidence ? (
        <ForeignForm
          onChange={onChangeForeign}
          onChanges={onChangesForeign}
          values={values?.foreign}
          errors={errors?.foreign as FormikErrors<ForeignVM>}
          touched={touched?.foreign as unknown as FormikTouched<ForeignVM>}
          disabled={disabled}
        />
      ) : (
        <ItalianForm
          onChange={onChangeItalian}
          onChanges={onChangesItalian}
          values={values?.italian}
          errors={errors?.italian as unknown as FormikErrors<ItalianVM>}
          touched={touched?.italian as unknown as FormikTouched<ItalianVM>}
          disabled={disabled}
        />
      )}
    </Grid>
  );
};

AccordionNewReidenceFormComponent.displayName = 'Accordion New Residence Form';

const AccordionNewReidenceForm = memo(AccordionNewReidenceFormComponent);

export default AccordionNewReidenceForm;
